<template>
  <div>
    <el-row :gutter="15">

      <el-col :span="12">
        <el-card style="height:calc(50vh - 65px);">
          <el-row>
            <el-col>
              <el-date-picker style="float: left;width:300px;margin-bottom: 10px;" value-format="yyyy-MM-dd"
                v-model="dateTimeDevice" type="daterange" size="small" class="query" range-separator="至"
                start-placeholder="保养开始日期起始" end-placeholder="保养开始日期结束" clear-icon @change="() => {
                  loadDeviceinfo()
                }">
              </el-date-picker>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-table :data="devicelistinfo.list" ref="deivceTable" show-overflow-tooltip border stripe size="mini"
                height="calc(50vh - 160px)" v-loading="loading">

                <el-table-column type="index" label="序号" width="50" align="center">
                </el-table-column>
                <el-table-column prop="name" label="工区名称"> </el-table-column>
                <el-table-column prop="value" label="设备数"> </el-table-column>
                <el-table-column prop="per" label="百分比(%)">
                </el-table-column>
              </el-table>
            </el-col>
            <el-col :span="12">
              <div id="elePiedevicelist" style="width: 100%;   height:calc(50vh - 160px);">

              </div>

            </el-col>
          </el-row>

        </el-card>

      </el-col>
      <el-col :span="12">
        <el-card style="height:calc(50vh - 65px);">
          <el-row>
            <el-col>
              <el-date-picker style="float: left;width:300px;margin-bottom: 10px;" value-format="yyyy-MM-dd"
                v-model="dateTimeSingletask" type="daterange" size="small" class="query" range-separator="至"
                start-placeholder="保养开始日期起始" end-placeholder="保养开始日期结束" clear-icon @change="() => {
                  loadSingletaskinfo()
                }">
              </el-date-picker>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-table :data="singletaskinfo.list" ref="singletaskTable" show-overflow-tooltip border stripe size="mini"
                height="calc(50vh - 160px)" v-loading="loading">

                <el-table-column type="index" label="序号" width="50" align="center">
                </el-table-column>
                <el-table-column prop="work_area_name" label="工区名称"> </el-table-column>
                <el-table-column prop="name" label="计划名称"> </el-table-column>
                <el-table-column prop="total_count" label="计划保养总数">
                </el-table-column>
                <el-table-column prop="finish_count" label="兑现保养总数">
                </el-table-column>
                <el-table-column prop="not_finish_count" label="未兑现保养数">
                </el-table-column>
                <el-table-column prop="rate" label="完成率(%)">
                </el-table-column>
              </el-table>
              <div class="es-page-box">
                <es-pagination :data="singletaskinfo"
                  @change="(cpage) => { this.querySingletaskObj.pageNum = cpage; this.loadSingletaskinfo() }">
                </es-pagination>
              </div>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="15">

      <el-col :span="12">
        <el-card style="height:calc(50vh - 65px);margin-top: 10px;">
          <el-row>
            <el-col>
              <el-date-picker style="float: left;width:300px;margin-bottom: 10px;" value-format="yyyy-MM-dd"
                v-model="dateTimeAreatask" type="daterange" size="small" class="query" range-separator="至"
                start-placeholder="保养开始日期起始" end-placeholder="保养开始日期结束" clear-icon @change="() => {
                  loadAreataskinfo()
                }">
              </el-date-picker>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-table :data="areataskinfo.list" ref="areataskTable" show-overflow-tooltip border stripe size="mini"
                height="calc(50vh - 160px)" v-loading="loading">

                <el-table-column type="index" label="序号" width="50" align="center">
                </el-table-column>
                <el-table-column prop="name" label="工区名称"> </el-table-column>
                <el-table-column prop="totalcount" label="计划设备总数">
                </el-table-column>
                <el-table-column prop="finishcount" label="兑现保养">
                </el-table-column>
                <el-table-column prop="rate" label="完成率(%)">
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>

        </el-card>

      </el-col>
      <el-col :span="12">
        <el-card style="height:calc(50vh - 65px);margin-top: 10px;">
          <el-row>
            <el-col>
              <el-date-picker style="float: left;width:300px;margin-bottom: 10px;" value-format="yyyy-MM-dd"
                v-model="dateTimeTop" type="daterange" size="small" class="query" range-separator="至"
                start-placeholder="保养开始日期起始" end-placeholder="保养开始日期结束" clear-icon @change="() => {
                  loadTopinfo()
                }">
              </el-date-picker>
            </el-col>
          </el-row>
          <div id="eleMaintaintop" style="width:100%;height:calc(50vh - 160px);margin-top: 10px;">
          </div>
        </el-card>
      </el-col>

    </el-row>

</div>
</template>

<script>
import dateutils from '../../utils/dateutils.js'

export default {
  name: 'maintainstatistic',
  data () {
    return {

      queryDeviceObj: { pageNum: 1, pageSize: 1000, starttime: [], endtime: [] },//查询设备条件
      querySingletaskObj: { pageNum: 1, pageSize: 1000, starttime: [], endtime: [] },//查询每个任务查询条件
      queryAreataskObj: { pageNum: 1, pageSize: 1000, starttime: [], endtime: [] },//查询工区任务完成条件
      queryTopObj: { starttime: [], endtime: [] },//查询兑现率排名条件


      dateTimeDevice: [],
      dateTimeSingletask: [],
      dateTimeAreatask: [],
      dateTimeTop: [],

      devicelistinfo: {},
      devicelist: {},
      devicepie: [],
      singletaskinfo: [],
      areataskinfo: [],
      topinfo: [],

      loading: false,


    }
  },
  methods: {
    //页面初始化
    init () {
      let millisecond = 1000 * 60 * 60 * 24;
      this.dateTimeDevice = [dateutils.dateFormat("YYYY-mm-dd 00:00:00", new Date((new Date()).getTime() - 7 * millisecond)), dateutils.dateFormat("YYYY-mm-dd 23:59:59", new Date())]
      this.dateTimeSingletask = [dateutils.dateFormat("YYYY-mm-dd 00:00:00", new Date((new Date()).getTime() - 7 * millisecond)), dateutils.dateFormat("YYYY-mm-dd 23:59:59", new Date())]
      this.dateTimeAreatask = [dateutils.dateFormat("YYYY-mm-dd 00:00:00", new Date((new Date()).getTime() - 7 * millisecond)), dateutils.dateFormat("YYYY-mm-dd 23:59:59", new Date())]
      this.dateTimeTop = [dateutils.dateFormat("YYYY-mm-dd 00:00:00", new Date((new Date()).getTime() - 7 * millisecond)), dateutils.dateFormat("YYYY-mm-dd 23:59:59", new Date())]

      this.loadDeviceinfo()
      this.loadSingletaskinfo()
      this.loadAreataskinfo()
      this.loadTopinfo()
    },

    loadDeviceinfo () {

      //设备表格
      this.loading = true
      this.queryDeviceObj.starttime = this.dateTimeDevice[0]
      this.queryDeviceObj.endtime = this.dateTimeDevice[1]
      this.$ajax.get('/buss/statisticmaintain/loaddeviceinfo', this.queryDeviceObj).then(msg => {
        this.devicelistinfo = msg
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })

      //设备饼图
      this.$ajax.get('/buss/statisticmaintain/loaddevicelist', this.queryDeviceObj).then(msg => {
        this.devicelist = msg
        this.initdevicelistPie()
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },

    initdevicelistPie () {
      let myChart = this.$echarts.init(document.getElementById('elePiedevicelist'))
      var colorList = ['#f1bb4c', '#BEE5FB', '#1EE7E7', '#00D68A', '#1890FF', '#564AF1', '#afa3f5', '#40d488', '#3feed4', '#3bafff', '#f1bb4c', '#aff', '#afa3f5', '#00d488', '#3feed4', '#3bafff', '#f1bb4c', '#aff', '#afa3f5', '#00d488', '#3feed4', '#3bafff', '#f1bb4c', '#aff',];
      var option = {
        title: {
          subtext: '工区保养设备占比',
          x: 'center',
          y: '2%',
          textStyle: {
            fontSize: 18,
            fontWeight: 'normal',
            color: ['#333']
          },
          subtextStyle: {
            color: '#f1bb4c',
            fontSize: 16
          },
        },
        grid: {
          bottom: 150,
          left: 0,
          right: '10%'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          show: false,
          orient: 'vertical',
          top: "middle",
          right: "5%",
          textStyle: {
            color: '#f2f2f2',
            fontSize: 25,
          },
          icon: 'roundRect'
        },
        series: [
          // 主要展示层的
          {
            radius: ['19%', '63%'],
            center: ['50%', '60%'],
            name: '工区名称',
            type: 'pie',
            itemStyle: {
              normal: {
                color: function (params) {
                  return colorList[params.dataIndex]
                }
              }
            },
            labelLine: {
              normal: {
                show: false,
                length: 5,
                length2: 60,
                lineStyle: {
                  color: '#d3d3d3'
                },
                align: 'right'
              },
              color: "#000",
              emphasis: {
                show: false
              }
            },
            label: {
              normal: {
                formatter: function (params) {
                  var str = params.name + params.value;
                  return str
                },
                padding: [0, -90],
                height: 35,
              }
            },
            data: this.devicelist,
          },
          // 边框的设置
          {
            radius: ['58%', '65%'],
            center: ['50%', '60%'],
            type: 'pie',
            label: {
              normal: {
                show: false
              },
              emphasis: {
                show: false
              }
            },
            labelLine: {
              normal: {
                show: false
              },
              emphasis: {
                show: false
              }
            },
            animation: false,
            tooltip: {
              show: false
            },
            itemStyle: {
              normal: {
                color: 'rgba(250,250,250,0.5)'
              }
            },
            data: [{
              value: 1,
            }],
          }
        ]
      };
      myChart.setOption(option)
    },

    loadSingletaskinfo () {
      //每个任务表格
      this.loading = true
      this.querySingletaskObj.starttime = this.dateTimeSingletask[0]
      this.querySingletaskObj.endtime = this.dateTimeSingletask[1]
      this.$ajax.get('/buss/statisticmaintain/loadsingletaskinfo', this.querySingletaskObj).then(msg => {
        this.singletaskinfo = msg
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },

    loadAreataskinfo () {
      //每个工区任务
      this.loading = true
      this.queryAreataskObj.starttime = this.dateTimeAreatask[0]
      this.queryAreataskObj.endtime = this.dateTimeAreatask[1]
      this.$ajax.get('/buss/statisticmaintain/loadareataskinfo', this.queryAreataskObj).then(msg => {
        this.areataskinfo = msg
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })

    },
    loadTopinfo () {
      //每个工区任务
      this.loading = true
      this.queryTopObj.starttime = this.dateTimeTop[0]
      this.queryTopObj.endtime = this.dateTimeTop[1]
      this.$ajax.get('/buss/statisticmaintain/loadtopinfo', this.queryTopObj).then(msg => {
        this.topinfo = msg
        console.log(msg)
        var dateKey = []
        var dateValue = []

        for (var i = 0; i < msg.length; i++) {
          dateKey.push(msg[i].name)
          dateValue.push(msg[i].rate)
        }

        this.initTopinfoEChart(dateKey, dateValue)




        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })


    },

    initTopinfoEChart (dateKey, dateValue) {
      let myChart = this.$echarts.init(document.getElementById('eleMaintaintop'))
      var option = {
        title: {
          text: '工区兑现率排名',
          left: 'center',
        },
        xAxis: {
          type: 'category',
          data: dateKey,
          axisLabel: {
            showMaxLabel: true,
            interval: 0,
            rotate: 40,
          }
        },
        yAxis: {
          type: 'value',
          name: "单位：%",
        },
        series: [
          {
            data: dateValue,
            barWidth: 20,
            type: 'bar'
          }
        ]
      };
      myChart.setOption(option)
    }

  },

  mounted () {
    this.init()
  }
}
</script>
<style scoped>
.cbottomshadow {
  width: 75%;
  height: 120px;
  margin-left: 25px;
  margin-top: 50px;
  line-height: 50px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  background: -webkit-gradient(linear,
      0% 0%,
      0% 20%,
      from(#409eff),
      to(#409eff));
  border-radius: 10px;
}
</style>
